import { c as _c } from "react/compiler-runtime";
import { DESIGN_SYSTEM_COOKIE, DESIGN_SYSTEM_QUERY_PARAM, getDesignSystemOverride, isDesignSystemOverrideEnabled } from '@src/lib/designSystemOverride';
import Cookie from 'js-cookie';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

// `?designSystem=next` turns the preview design system on, `?designSystem=sco` turns it off.
// Reloads without the param so SSR renders with the new cookie.
export const DesignSystemQueryHandler = () => {
  const $ = _c(6);
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get(DESIGN_SYSTEM_QUERY_PARAM);
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const requested = t0;
  let t1;
  let t2;
  if ($[2] !== requested) {
    t1 = () => {
      if (!isDesignSystemOverrideEnabled || requested == null) {
        return;
      }
      const override = getDesignSystemOverride(requested);
      if (override) {
        Cookie.set(DESIGN_SYSTEM_COOKIE, override, {
          expires: 30
        });
      } else {
        Cookie.remove(DESIGN_SYSTEM_COOKIE);
      }
      const url = new URL(window.location.href);
      url.searchParams.delete(DESIGN_SYSTEM_QUERY_PARAM);
      window.location.replace(url.toString());
    };
    t2 = [requested];
    $[2] = requested;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <></>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};